// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { getProviderAppEnvConfig } from '../config/env';

let promise: Promise<Stripe | null> | undefined;

/**
 * Lazily loads Stripe.js once and caches the resulting promise.
 * Throws synchronously if VITE_STRIPE_PUBLISHABLE_KEY is missing so the UI
 * can surface a clear setup error instead of failing later in the card form.
 */
export function getStripePromise(): Promise<Stripe | null> {
  if (!promise) {
    const key = getProviderAppEnvConfig().stripePublishableKey;
    if (!key) {
      throw new Error('VITE_STRIPE_PUBLISHABLE_KEY is not set');
    }
    promise = loadStripe(key);
  }
  return promise;
}
